import { SVGProps, Ref, forwardRef } from 'react'
const SvgFileUploadCloud = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 23.25v-9M8.25 18 12 14.25 15.75 18"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.25 15.75h1.125a4.875 4.875 0 1 0-2.764-8.885 7.5 7.5 0 1 0-8.86 8.735"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgFileUploadCloud)
export default ForwardRef
